exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "form#detenteur h2{text-transform:uppercase;margin-bottom:10px;border-bottom:1px solid #ccc;padding-bottom:5px}.get-position{margin-left:auto;margin-top:20px;margin-right:10px;height:40px;width:50px;font-size:3rem;padding-left:4.5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-446fd5b6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/detenteur/Detenteur.vue
// module id = 627
// module chunks = 0